import { ComponentType, TableHTMLAttributes } from 'react'
import tw from 'tailwind-styled-components'

import TableBody from './TableBody'
import TableColumn from './TableColumn'
import TableHead from './TableHead'
import TableRow from './TableRow'
import TableTitle from './TableTitle'

type TableComposition = {
  Body: typeof TableBody
  Column: typeof TableColumn
  Head: typeof TableHead
  Row: typeof TableRow
  Title: typeof TableTitle
}

type TableProps = TableHTMLAttributes<HTMLTableElement>

const TableComponent = tw.table<TableProps>`
  min-w-full
  border
  border-gray-200
`

const Table = TableComponent as unknown as ComponentType<TableProps> &
  TableComposition

Table.Body = TableBody
Table.Column = TableColumn
Table.Head = TableHead
Table.Row = TableRow
Table.Title = TableTitle

export default Table
